import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Headers, Http, RequestOptions} from '@angular/http';
import {environment} from '../../environments/environment';

import {UserService} from '../service/user.service';

@Component({
  selector: 'activation',
  templateUrl: './activation.component.html'
})
export class ActivationComponent {
  currentUser: any;
  password: string;
  passwordconfirm: string;
  public showError: boolean;
  public errorMessage: string;

  constructor(private router: Router,
              private http: Http,
              private activateRoute: ActivatedRoute,
              private userService: UserService) {

    localStorage.removeItem('auth_token');
    localStorage.removeItem('code_token');
    localStorage.removeItem('current_user');

    this.currentUser = {
      password: '',
      passwordconfirm: ''
    };
  }

  ngOnInit() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('code_token');
    localStorage.removeItem('current_user');
  }

  activateUser() {
    this.showError = false;
    this.errorMessage = '';

    this.password = this.currentUser.password;
    this.passwordconfirm = this.currentUser.passwordconfirm;
    if (!(new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$').test(this.currentUser.password))) {
      this.showError = true;
      this.errorMessage = 'Passwords must contains at least one capital letter one small letter number and special character';
      return;
    }

    if (this.currentUser.password !== this.currentUser.passwordconfirm) {
      this.showError = true;
      this.errorMessage = 'Password and confirm must match';
      return;
    }

    const params =
      {
        password: this.password,
        password_confirm: this.passwordconfirm
      };

    const body = JSON.stringify(params);
    const token = this.activateRoute.snapshot.queryParams['token'];

    const headers = new Headers({'Content-Type': 'application/json'});
    headers.append('Authorization', token);
    const options = new RequestOptions({headers: headers});

    return this.http
      .post(environment.baseUrl + '/users/validate', body, options)
      .subscribe(data => {
          const responseObject = JSON.parse(data['_body']);

          this.userService.login(responseObject['detail'].email, this.password)
            .subscribe((result) => {
                if (result)
                  this.router.navigate(['/verification']);
              },
              err => {
                this.errorMessage = 'Something went wrong loging you in';
                this.showError = true;
              })
        },
        err => {
          this.errorMessage = 'The token given is invalid';
          this.showError = true;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/activation/activation.component.ts